module.exports = __webpack_public_path__ + "static/media/parcel-locker.98beea7e.svg";